// allg. Utilities für die Top- und Footer-Navigation
mp.nav = {
    init: function () {
        mp.nav.mySearchHistory();
        mp.nav.myBookmarks();

        $('.mpScrollTop').on('click', mp.nav.scrollTop);
    },

    scrollTop: function(ev) {
        ev.preventDefault();
        $(window).scrollTo(0, 300);
    },

    mySearchHistory: function () {
        try {
            var search = Cookies.get('MP_EntityHistory').split(':');
            if (search.length > 0) {
                $('.mpSearchHistory:not(.mobile)')
                    .attr('data-count', ' (' + search.length + ')')
                    .addClass('visible');
            }
        } catch (e) {
            $('.mpSearchHistory:not(.mobile)')
                .attr('data-count', '')
                .addClass('visible');
        }
    },

    myBookmarks: function () {
        try {
            var bookmarks = Cookies.get('MP_MemorizedOffers').split(':');
            if (bookmarks.length > 0) {
                $('.mpBookmark:not(.mobile)')
                    .attr('data-count', ' (' + bookmarks.length + ')')
                    .addClass('visible');
            }
        } catch (e) {
            $('.mpBookmark:not(.mobile)')
                .attr('data-count', '')
                .addClass('visible');
        }
    }
};

$(document).ready(function () {
    mp.nav.init();
});